import { render, staticRenderFns } from "./UpPassword.vue?vue&type=template&id=99c7e84a&scoped=true"
import script from "./UpPassword.vue?vue&type=script&lang=js"
export * from "./UpPassword.vue?vue&type=script&lang=js"
import style0 from "./UpPassword.vue?vue&type=style&index=0&id=99c7e84a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c7e84a",
  null
  
)

export default component.exports